module.exports = __webpack_public_path__ + "img/icon_actinum.76f083ba.png";